<template>
  <footer class="app-footer">
    <a href="http://coreui.io">
      CoreUI
    </a>
    &copy; {{ getYear() }} creativeLabs.
    <span class="float-right">
      Powered by
      <a href="http://coreui.io">
        CoreUI
      </a>
    </span>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter',

  methods: {
    getYear() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Footer.vue?2e58d940